module.exports = __webpack_public_path__ + "static/media/COTK2_5.004fa102.png";